import { render, staticRenderFns } from "./SignUpOrganizationBody.vue?vue&type=template&id=7235bdc2"
import script from "./SignUpOrganizationBody.vue?vue&type=script&lang=js"
export * from "./SignUpOrganizationBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports